import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Product from "./Product";
import ProductSkelton from "./ProductSkelton";

import { productsItems } from "../../apis/productsApiSlice";

const ProductsList = ({ filterBy }) => {
  const products = useSelector(productsItems);

  const [isLoading, setIsLoading] = useState(true);
  const [loadCount, setLoadCount] = useState(8);
  const [searched, setSearched] = useState("");

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  }, [loadCount]);

  if (products?.length) {
    let productList;
    if (filterBy) {
      productList = products.filter(
        (product) => product.category.toLowerCase().indexOf(filterBy) >= 0
      );
    } else {
      productList = products;
    }

    const productItem = (product, index) => {
      return isLoading ? (
        <ProductSkelton key={index} />
      ) : (
        <Product product={product} key={index} />
      );
    };

    let errorContent = "";
    if (searched) {
      const filteredResult = productList.filter(
        (product) => product.title.toLowerCase().indexOf(searched) >= 0
      );

      if (!filteredResult.length) {
        errorContent = (
          <div className="flex justify-center mt-40">No product found.!</div>
        );
      }
    }

    return (
      <>
        <div className="w-full max-w-sm min-w-[200px] ml-auto mr-0 mb-8">
          <div className="relative">
            <input
              className="peer w-full relative z-20 focus:z-0 bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-secondary border-slate-200 rounded-md px-3 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow"
              style={{ backgroundColor: "transparent" }}
              onChange={(e) => {
                setSearched(e.target.value.toLowerCase());
              }}
              disabled={isLoading}
            />
            <label className="absolute capitalize z-10 cursor-text bg-white px-1 left-2.5 top-2.5 text-slate-400 text-sm transition-all transform origin-left peer-focus:-top-2 peer-focus:left-2.5 peer-focus:text-xs peer-focus:text-slate-400 peer-focus:scale-90">
              Search {filterBy ? filterBy : "product"}...
            </label>
          </div>
        </div>
        {errorContent}
        <div className="flex flex-wrap gap-8">
          {productList?.length > 0 &&
            productList.map((product, index) =>
              searched
                ? product.title.toLowerCase().indexOf(searched) >= 0 &&
                  productItem(product, index)
                : index < loadCount && productItem(product, index)
            )}
        </div>
        <div className="text-center">
          {loadCount < productList?.length && !searched && (
            <button
              className="bg-secondary py-4 px-6 mt-20 mx-auto rounded-md"
              onClick={() => {
                setIsLoading(true);
                setLoadCount(productList.length > loadCount + 4 ? loadCount + 4 : productList.length);
              }}
              disabled={isLoading}
            >
              Load more
            </button>
          )}
        </div>
      </>
    );
  }
};

export default ProductsList;
